import { Link, useNavigate } from 'react-router-dom';
import { MenuTrigger, Button, Popover, Menu, MenuItem } from 'react-aria-components';
import { NavigateRoutesEnum } from '@routing/routesEnum';
import smallMenuIcon from '@assets/icons/small-menu-icon.svg';



const SmallMenu = (): JSX.Element => {

	const navigate = useNavigate();

	return (
		<div className='header-section small-menu-section'>
			<MenuTrigger>

				<Button className='small-menu-button disable-selection' autoFocus={false}>
					<img src={smallMenuIcon} alt='small-menu-button-icon' />
				</Button>

				<Popover>
					<Menu onAction={(key: string | number) => navigate(String(key))} autoFocus={false}>
						
						<MenuItem id={NavigateRoutesEnum.about} textValue='Proč Vetlímce'>
							<Link to={NavigateRoutesEnum.about}>proč Vetlímce</Link>
						</MenuItem>
						
						<MenuItem id={NavigateRoutesEnum.gallery} textValue='Galerie'>
							<Link to={NavigateRoutesEnum.gallery}>galerie</Link>
						</MenuItem>
						
						<MenuItem id={NavigateRoutesEnum.partners} textValue='Pro partnery'>
							<Link to={NavigateRoutesEnum.partners}>pro partnery</Link>
						</MenuItem>

						<MenuItem id={NavigateRoutesEnum.faq} textValue='Nejčastější dotazy'>
							<Link to={NavigateRoutesEnum.faq}>nejčastější dotazy</Link>
						</MenuItem>

						<MenuItem id={NavigateRoutesEnum.salesNetwork} textValue='partnerské veteriny'>
							<Link to={NavigateRoutesEnum.salesNetwork}>partnerské veteriny</Link>
						</MenuItem>
					
					</Menu>
				</Popover>

			</MenuTrigger>
		</div>
	);
}

export default SmallMenu;